export default "__VITE_ASSET__DrCWesur__"